<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>

        <!-- <Spinner ref="spinner"></Spinner> -->

        <v-layout text-xs-center>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-3 align-center>
              <v-flex>
                <v-layout row>
                  <v-icon class="mr-2">fa-plus-circle</v-icon>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Edit Charge</div>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-form v-model="valid2" @submit="showForm" ref="formFilters">

                  <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                    <v-layout hide-details justify-start row mt-0 mb-4>

                      <v-flex hide-details mx-4>
                        <!-- <v-text-field
                          style="max-height: 45px"
                          v-model="charge.AccountNumber"
                          value="AccountNumber"
                          label="Account*"
                          type="number"
                          :disabled="isAccountNumberDisabled"
                          required
                          :rules="accountNumberRules"
                        ></v-text-field> -->
                        <v-autocomplete
                          hide-details
                          :items="ddlAccounts"
                          v-model="charge.AccountNumber"
                          item-text="Text"
                          item-value="Value"
                          label="Account*"
                          clearable
                          :disabled="isAccountNumberDisabled"
                          required
                          :rules="accountNumberRules"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex hide-details mx-4>
                        <!-- <v-text-field
                          style="max-height: 45px"
                          v-model="charge.ServiceIdentifier"
                          value="ServiceIdentifier"
                          label="Service Identifier"
                          :disabled="isServiceIdentifierDisabled"
                          hint="Leave blank to create Account Level Charge"
                          persistent-hint
                        ></v-text-field> -->
                        <v-autocomplete
                          :items="ddlServices"
                          v-model="charge.ServiceId"
                          item-text="Text"
                          item-value="Value"
                          label="Service"
                          clearable
                          :disabled="isServiceIdentifierDisabled"
                          hint="Leave blank to create Account Level Charge"
                          persistent-hint
                        ></v-autocomplete>
                      </v-flex>

                    </v-layout>
                  </v-layout>

                  <!-- <v-layout hide-details justify-end row mt-0 mb-4>
                    <a
                      class="align-center mx-4 pt-3"
                      style="text-decoration: none"
                      @click="resetFormFilters"
                    >RESET</a>
                    <v-btn
                      color="success"
                      @click="showForm()"
                      class="ml-2 mr-4"
                    >
                      Show Form
                    </v-btn>
                  </v-layout> -->

            </v-form>

            <v-divider class="mr3"></v-divider>

            <v-flex mb-0 xs12 mx-2 v-if="isAccountChargeFormVisible">
            <!-- <v-flex mb-0 xs12 mx-2 v-if="false"> -->

              <v-layout justify-start row mx-3 mt-3 align-center>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Account Level Charge</div>
              </v-layout>

              <v-form v-model="valid" @submit="editAccountCharge" ref="createAccountChargeForm">

                    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                      <v-layout hide-details justify-start row mt-0 mb-4>

                        <v-flex hide-details mx-4 xs4>

                          <v-autocomplete
                            hide-details
                            :items="ddlChargeType"
                            v-model="charge.ChargeType"
                            item-text="Text"
                            item-value="Value"
                            label="Charge Type*"
                            clearable
                            required
                            :rules="chargeTypeRules"
                            :disabled="isChargeTypeDisabled"
                          ></v-autocomplete>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="charge.BillPrintText"
                            value="BillPrintText"
                            label="Description for Bill Presentation"
                            @input="forceUpperCase('BillPrintText')"
                          ></v-text-field>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="charge.ContractNumber"
                            value="ContractNumber"
                            label="Contract No.*"
                            @input="forceUpperCase('ContractNumber')"
                            required
                            :rules="contractNumberRules"
                          ></v-text-field>

                        </v-flex>

                        <v-flex hide-details mx-4 xs4>

                          <v-menu
                            v-model="menu"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="charge.ContractDate"
                              label="Contract Date*"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                              required
                              :rules="contractDateRules"
                            ></v-text-field>
                            <v-date-picker v-model="charge.ContractDate" @input="menu = false"></v-date-picker>
                          </v-menu>

                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="charge.EffectiveDate"
                              label="Effective Date*"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                              required
                              :rules="effectiveDateRules"
                            ></v-text-field>
                            <v-date-picker v-model="charge.EffectiveDate" @input="menu2 = false"></v-date-picker>
                          </v-menu>

                          <v-menu
                            v-model="menu3"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="charge.EndDate"
                              label="End Date"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                            ></v-text-field>
                            <v-date-picker v-model="charge.EndDate" @input="menu3 = false"></v-date-picker>
                          </v-menu>

                        </v-flex>


                        <v-flex hide-details mx-4 xs4>

                          <v-autocomplete
                            hide-details
                            :items="ddlSalesId"
                            v-model="charge.SalesId"
                            item-text="Text"
                            item-value="Value"
                            label="Sales Id*"
                            clearable
                            required
                            :rules="salesIdRules"
                          ></v-autocomplete>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="charge.Amount"
                            value="Amount"
                            label="Amount ($)*"
                            type="number"
                            required
                            :rules="amountRules"
                          ></v-text-field>
                          <v-autocomplete
                            hide-details
                            :items="ddlFrequency"
                            v-model="charge.Frequency"
                            item-text="Text"
                            item-value="Value"
                            label="Frequency*"
                            clearable
                            required
                            :rules="frequencyRules"
                          ></v-autocomplete>

                        </v-flex>

                      </v-layout>
                    </v-layout>

                    <v-layout hide-details justify-end row mt-0 mb-4>
                      <!-- <a
                        class="align-center mx-4 pt-3"
                        style="text-decoration: none"
                        @click="resetCreateWirelessServiceForm"
                      >RESET</a> -->
                      <v-btn
                        color="success"
                        @click="editAccountCharge()"
                        class="ml-2 mr-4"
                      >
                        Save
                      </v-btn>
                    </v-layout>

              </v-form>

            </v-flex>

            <v-flex mb-0 xs12 mx-2 v-if="isServiceChargeFormVisible">
            <!-- <v-flex mb-0 xs12 mx-2 v-if="true"> -->

              <v-layout justify-start row mx-3 mt-3 align-center>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Service Level Charge</div>
              </v-layout>

              <v-form v-model="valid" @submit="editServiceCharge" ref="createServiceChargeForm">

                    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                      <v-layout hide-details justify-start row mt-0 mb-4>

                        <v-flex hide-details mx-4 xs4>

                          <v-autocomplete
                            hide-details
                            :items="ddlChargeType"
                            v-model="charge.ChargeType"
                            item-text="Text"
                            item-value="Value"
                            label="Charge Type*"
                            clearable
                            required
                            :rules="chargeTypeRules"
                            :disabled="isChargeTypeDisabled"
                          ></v-autocomplete>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="charge.BillPrintText"
                            value="BillPrintText"
                            label="Description for Bill Presentation"
                            @input="forceUpperCase('BillPrintText')"
                          ></v-text-field>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="charge.ContractNumber"
                            value="ContractNumber"
                            label="Contract No.*"
                            @input="forceUpperCase('ContractNumber')"
                            required
                            :rules="contractNumberRules"
                          ></v-text-field>

                        </v-flex>

                        <v-flex hide-details mx-4 xs4>

                          <v-menu
                            v-model="menu"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="charge.ContractDate"
                              label="Contract Date*"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                              required
                              :rules="contractDateRules"
                            ></v-text-field>
                            <v-date-picker v-model="charge.ContractDate" @input="menu = false"></v-date-picker>
                          </v-menu>

                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="charge.EffectiveDate"
                              label="Effective Date*"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                              required
                              :rules="effectiveDateRules"
                            ></v-text-field>
                            <v-date-picker v-model="charge.EffectiveDate" @input="menu2 = false"></v-date-picker>
                          </v-menu>

                          <v-menu
                            v-model="menu3"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="charge.EndDate"
                              label="End Date"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                            ></v-text-field>
                            <v-date-picker v-model="charge.EndDate" @input="menu3 = false"></v-date-picker>
                          </v-menu>

                        </v-flex>


                        <v-flex hide-details mx-4 xs4>

                          <v-autocomplete
                            hide-details
                            :items="ddlSalesId"
                            v-model="charge.SalesId"
                            item-text="Text"
                            item-value="Value"
                            label="Sales Id*"
                            clearable
                            required
                            :rules="salesIdRules"
                          ></v-autocomplete>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="charge.Amount"
                            value="Amount"
                            label="Amount ($)*"
                            type="number"
                            required
                            :rules="amountRules"
                          ></v-text-field>
                          <v-autocomplete
                            hide-details
                            :items="ddlFrequency"
                            v-model="charge.Frequency"
                            item-text="Text"
                            item-value="Value"
                            label="Frequency*"
                            clearable
                            required
                            :rules="frequencyRules"
                          ></v-autocomplete>

                        </v-flex>

                      </v-layout>
                    </v-layout>

                    <v-layout hide-details justify-end row mt-0 mb-4>
                      <!-- <a
                        class="align-center mx-4 pt-3"
                        style="text-decoration: none"
                        @click="resetCreateWirelessServiceForm"
                      >RESET</a> -->
                      <v-btn
                        color="success"
                        @click="editServiceCharge()"
                        class="ml-2 mr-4"
                      >
                        Save
                      </v-btn>
                    </v-layout>

              </v-form>

            </v-flex>

          </v-flex>
        </v-layout>

    </v-card>
  </v-dialog>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import axios from "axios";
import Bus from "../../bus";
import moment from 'moment';

export default {
  name: "EditCharge",

  components: {
    Spinner,
  },

  data: () => ({
    dialog: false,
    valid: true,
    valid2: true,

    menu: false,
    menu2: false,
    menu3: false,

    isAccountNumberDisabled: true,
    isServiceIdentifierDisabled: true,
    isChargeTypeDisabled: true,

    isAccountChargeFormVisible: false,
    isServiceChargeFormVisible: false,

    accountBAN: '',
    accountName: '',

    ddlAccounts: [],
    ddlServices: [],

    ddlChargeType: [],
    ddlSalesId: [],
    ddlFrequency: [],

    accountNumberRules: [v => !!v || ""],

    chargeTypeRules: [v => !!v || ""],
    contractNumberRules: [v => !!v || ""],
    contractDateRules: [v => !!v || ""],
    effectiveDateRules: [v => !!v || ""],
    salesIdRules: [v => !!v || ""],
    amountRules: [v => (!!v || v === 0) || ""],
    frequencyRules: [v => !!v || ""],

    charge: {},

    tempAmount: 0,
  }),

  mounted() {
    this.initialize();
  },

  methods: {
    initialize () {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async open(item) {
      await this.getResponseData("api/Charge/GetEditChargeInfo/" + item.ChargeId, "charge")
      this.getElementData("/api/Charge/GetEditChargeInfo/" + item.ChargeId, "ddlFrequency")
      this.getResponseData("api/Account/GetAllAccountsDDL/", "ddlAccounts")
      this.getResponseData("api/Services/GetAllServicesForAccountDDL/" + this.charge.AccountNumber, "ddlServices")
      
      this.charge.ChargeType = this.charge.ChargeType.toString()
      this.charge.ContractDate = this.charge.ContractDate.split('T')[0]
      this.charge.EffectiveDate = this.charge.EffectiveDate.split('T')[0]
      this.charge.EndDate = this.charge.EndDate ? this.charge.EndDate.split('T')[0] : null
      this.charge.AccountNumber = this.charge.AccountNumber
      this.charge.ServiceId = this.charge.ServiceId ? this.charge.ServiceId.toString() : null,
      this.charge.ChargeId = item.ChargeId

      this.dialog = true;
      this.showForm()
    },

    cancel() {
      this.dialog = false;

      this.resetFormFilters()
    },

    resetFormFilters() {
      this.$refs.formFilters.resetValidation()

      this.charge = {}
      this.isAccountChargeFormVisible = false
      this.isServiceChargeFormVisible = false
    },

    async editAccountCharge() {
      if (this.$refs.createAccountChargeForm.validate()) {
        let result = await this.saveAccountChargeChangesToDB()

        if (result) {
          this.$root.$emit("initialize", this.initialize);

          Bus.$emit("alert", {
            color: "success",
            message: "Account Level Charge Updated Successfully!"
          });
        }

        // window.location.reload();
        this.cancel()
      }
    },
    async saveAccountChargeChangesToDB() {

      let result = await axios.post("api/Charge/EditCharge", this.charge);
      return result;
    },

    async editServiceCharge() {
      if (this.$refs.createServiceChargeForm.validate()) {
        let result = await this.saveServiceChargeChangesToDB()

        if (result) {
          this.$root.$emit("initialize", this.initialize);

          Bus.$emit("alert", {
            color: "success",
            message: "Service Level Charge Updated Successfully!"
          });
        }

        // window.location.reload();
        this.cancel()
      }
    },
    async saveServiceChargeChangesToDB() {

      let result = await axios.post("api/Charge/EditCharge", this.charge);
      return result;
    },

    forceUpperCase(prop) {
      this.charge[`${prop}`] = this.charge[`${prop}`].toUpperCase()
    },

    async showForm() {
      if (this.charge.AccountNumber) {
        if (this.charge.ServiceId) {
          this.isAccountChargeFormVisible = false
          this.isServiceChargeFormVisible = true
          this.populateServiceChargeDlls()
        } else {
          this.isAccountChargeFormVisible = true
          this.isServiceChargeFormVisible = false
          this.populateAccountChargeDlls()
        }
      }
    },

    async updateAmountAndFrequencyDdl(ChargeTypeId) {
      if (ChargeTypeId) {
        this.getResponseData("api/Charge/GetFrequencyDDL/" + ChargeTypeId, "ddlFrequency")
        this.getPropData("api/Charge/GetChargeDefaultAmount/" + ChargeTypeId, "charge", "Amount")
        // this.getResponseData("api/Charge/GetChargeDefaultAmount/" + ChargeTypeId, "tempAmount")
        // this.charge.Amount = this.tempAmount
      } else {
        this.ddlFrequency = []
        this.charge.Amount = null
      }
    },

    async populateServiceDll() {
      if (this.charge.AccountNumber) {
        this.getResponseData("api/Services/GetAllServicesForAccountDDL/" + this.charge.AccountNumber, "ddlServices")
      }
    },

    populateAccountChargeDlls() {
      this.getElementData("api/Charge/GetAccountChargeDDLs", "ddlChargeType")
      this.getElementData("api/Charge/GetAccountChargeDDLs", "ddlSalesId")
      // this.getElementData("api/Charge/GetAccountChargeDDLs", "ddlFrequency")
      // this.showForm()
    },

    populateServiceChargeDlls() {
      this.getElementData("api/Charge/GetServiceChargeDDLs/" + this.charge.ServiceId, "ddlChargeType")
      this.getElementData("api/Charge/GetServiceChargeDDLs/" + this.charge.ServiceId, "ddlSalesId")
      // this.getElementData("api/Charge/GetServiceChargeDDLs", "ddlFrequency")
      // this.showForm()
    }
  }
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

